import React, { useState } from 'react';
import { Lock, CalendarClock, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { BOOK_A_CALL_URL } from '../config/constants';

const AccountDisabled: React.FC = () => {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleBookCall = () => {
    window.open(BOOK_A_CALL_URL, '_blank', 'noopener,noreferrer');
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-4 px-6 shadow-sm">
        <div className="container mx-auto flex items-center justify-center">
          <img src="/logo.png" alt="Bluepill Logo" className="h-14" />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-xl mx-auto text-center">
          {/* Icon */}
          <div className="relative mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-blue-100 rounded-full">
              <Lock className="w-12 h-12 text-blue-600" />
            </div>
          </div>

          {/* Message */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Your free access has ended</h1>

          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            Bluepill is now available through our team. Book a quick call and we'll get you set up
            with full access to run your audiences and simulations.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={handleBookCall}
              className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-3 bg-blue-600 text-white text-base font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
            >
              <CalendarClock className="w-5 h-5 mr-2" />
              Book a call
            </button>

            <button
              onClick={handleLogout}
              disabled={isLoggingOut}
              className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 text-base text-gray-600 hover:text-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <LogOut className="w-5 h-5 mr-2" />
              {isLoggingOut ? 'Logging out…' : 'Log out'}
            </button>
          </div>

          {/* Contact */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-1">Questions?</p>
            <a
              href="mailto:support@blue-pill.ai"
              className="text-blue-600 font-medium hover:underline"
            >
              support@blue-pill.ai
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6 px-4">
        <div className="container mx-auto text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Bluepill Inc.
        </div>
      </footer>
    </div>
  );
};

export default AccountDisabled;
